const addTargetBlank = function (htmlString) {
    return htmlString.replace(/<a\s+(?![^>]*\btarget=)[^>]*>/gi, match => {
        return match.replace('>', ' target="_blank">');
    });
};
export default addTargetBlank;
